// @core/api/endpoints/webhook/publish_events.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PublishEventsRequest,
  PublishEventsResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Publish events
 * Performs publish operation on events.
 */
export async function PublishEvents(
  data: PublishEventsRequest,
  options?: RequestOptions
): Promise<PublishEventsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/publish_events`;
  const requestOptions = options;
  return client.post<PublishEventsResponse>(requestPath, data, requestOptions);
}
